export const Careers = () => {
    return (
      <div>
        <p>This is the "The University" page</p>
       
      </div>
    );
  };
  